export default __webpack_public_path__ + "static/media/item-shoppinglist@2x.a5824992.png";